/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ActiveIngredientDto
 */
export interface ActiveIngredientDto {
    /**
     * Active ingredient name
     * @type {string}
     * @memberof ActiveIngredientDto
     */
    name: string;
    /**
     * Active ingredient strength
     * @type {string}
     * @memberof ActiveIngredientDto
     */
    strength: string;
}

/**
 * Check if a given object implements the ActiveIngredientDto interface.
 */
export function instanceOfActiveIngredientDto(value: object): value is ActiveIngredientDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('strength' in value) || value['strength'] === undefined) return false;
    return true;
}

export function ActiveIngredientDtoFromJSON(json: any): ActiveIngredientDto {
    return ActiveIngredientDtoFromJSONTyped(json, false);
}

export function ActiveIngredientDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActiveIngredientDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'strength': json['strength'],
    };
}

export function ActiveIngredientDtoToJSON(json: any): ActiveIngredientDto {
    return ActiveIngredientDtoToJSONTyped(json, false);
}

export function ActiveIngredientDtoToJSONTyped(value?: ActiveIngredientDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'strength': value['strength'],
    };
}

